module.exports = __webpack_public_path__ + "img/video-player/play_overlay-316f7a120b5dfdc206d8879726f416a1.svg";